import React from 'react';

export const CompletedSvg = () => (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.0747 5.48317C13.1913 5.94984 13.2497 6.47484 13.2497 6.99984C13.2497 10.2082 10.6247 12.8332 7.41634 12.8332C4.20801 12.8332 1.58301 10.2082 1.58301 6.99984C1.58301 3.7915 4.20801 1.1665 7.41634 1.1665C8.52467 1.1665 9.57467 1.45817 10.508 2.0415"
      //   stroke="#00D1DF"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.08301 5.83333L7.41634 8.16667L13.833 1.75"
      //   stroke="#00D1DF"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
